import { V1Amount } from '@/api/clients/ohip';

export const DISLOYALTY_MEMBERSHIP_PRICES = [
  {
    value: 14400,
    decimal: 2,
    currencyCode: 'GBP' as const,
  },
  {
    value: 18000,
    decimal: 2,
    currencyCode: 'EUR' as const,
  },
  {
    value: 21600,
    decimal: 2,
    currencyCode: 'USD' as const,
  },
  {
    value: 72000,
    decimal: 2,
    currencyCode: 'AED' as const,
  },
  {
    value: 16000,
    decimal: 2,
    currencyCode: 'CHF' as const,
  },
  {
    value: 124500,
    decimal: 2,
    currencyCode: 'DKK' as const,
  },
  {
    value: 344500,
    decimal: 2,
    currencyCode: 'ZAR' as const,
  },
  {
    value: 1950000,
    decimal: 2,
    currencyCode: 'RSD' as const,
  },
  {
    value: 71500,
    decimal: 2,
    currencyCode: 'QAR' as const,
  },
  {
    value: 25000,
    decimal: 2,
    currencyCode: 'SGD' as const,
  },
  {
    value: 30000,
    decimal: 2,
    currencyCode: 'AUD' as const,
  },
  {
    value: 150000,
    decimal: 2,
    currencyCode: 'HKD' as const,
  },
  {
    value: 268000,
    decimal: 0,
    currencyCode: 'KRW' as const,
  },
  {
    value: 622500,
    decimal: 2,
    currencyCode: 'THB' as const,
  },
  {
    value: 73000,
    decimal: 2,
    currencyCode: 'SAR' as const,
  },
] satisfies V1Amount[];

export type DisloyaltyMembershipSupportedCurrencyCode =
  (typeof DISLOYALTY_MEMBERSHIP_PRICES)[number]['currencyCode'];
